export default __webpack_public_path__ + "static/media/join_community_background.a0b9d5cc.svg";